import GET_CATEGORIES from "../plugins/getCategories";

const [ content ] = [ 'information' ];
 
const init = () => {

  // カテゴリ一覧取得
  $(`.${content}-catelist`,'.block_head').insertAfter('.breadcrumbs');
  GET_CATEGORIES(`.${content}-catelist[data-plugin="getCategories"]`);
}

export default function INFO() {
  $( init );
}